import React, { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';

const Timer = ({ sendMsgHandler }: { sendMsgHandler: () => void }) => {
    const initialTime = 120;
    const [timeLeft, setTimeLeft] = useState(initialTime);
    const [isTimerActive, setIsTimerActive] = useState(false);

    useEffect(() => {
        setTimeLeft(initialTime);
        setIsTimerActive(true);
    }, []);

    useEffect(() => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let timer: any;
        if (isTimerActive && timeLeft > 0) {
            timer = setInterval(() => {
                setTimeLeft((prevTime) => prevTime - 1);
            }, 1000);
        } else if (timeLeft === 0) {
            clearInterval(timer);
            setIsTimerActive(false);
        }
        return () => clearInterval(timer);
    }, [isTimerActive, timeLeft]);

    const handleResendCode = () => {
        setTimeLeft(initialTime);
        setIsTimerActive(true);
        sendMsgHandler();
    };

    const formatTime = (seconds:number) => {
        const minutes = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${String(minutes).padStart(2, '0')}:${String(secs).padStart(
            2,
            '0',
        )}`;
    };

    return (
        <div>
            {timeLeft > 0 ? (
                <p className="text-center pt-2">
                    <span className="text-blue-500">
                        {formatTime(timeLeft)}
                    </span>{' '}
                    تا ارسال مجدد کد
                </p>
            ) : (
                <Button
                    onClick={handleResendCode}
                    className="mx-auto !pb-0 !pt-2 !block w-max bg-white"
                >
                    ارسال مجدد کد
                </Button>
            )}
        </div>
    );
};

export default Timer;
